import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useUserNotesEntitlement } from "./UserNotesEntitlementContext";
import { IS_STANDALONE } from "../../standalone/config";

/** 跳转「我的笔记」主页面；可选带上股票筛选 */
export function useMyNotesNavigate(spaceId: string) {
  const navigate = useNavigate();
  const { notesModule } = useUserNotesEntitlement();

  return useCallback(
    (stockCode?: string) => {
      const stock = stockCode?.trim();
      const q = stock ? `?stock=${encodeURIComponent(stock)}` : "";
      if (IS_STANDALONE) {
        navigate(`/tactik/notes${q}`);
        return;
      }
      const routeKey = notesModule?.spaceProductId?.trim();
      if (!routeKey) {
        return;
      }
      navigate(`/space/${spaceId}/${routeKey}${q}`);
    },
    [navigate, notesModule?.spaceProductId, spaceId]
  );
}
